import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Contrast } from "../../../types/general.types";
import { StyledShimmer } from "./Shimmer.style";
import { ShimmerVariants } from "./constants";
const Shimmer = ({ children = _jsx("div", { children: "Teste" }), variant = ShimmerVariants.linear, contrast = Contrast.default, show = true, ...props }) => {
    return (_jsx(_Fragment, { children: show ? (_jsx(StyledShimmer, { variant: variant, contrast: contrast, ...props, children: children })) : (children) }));
};
export default Shimmer;
//# sourceMappingURL=Shimmer.js.map